import styled from 'styled-components'

interface IBudgetCategoryCardProgressBarStyledProps {}

export const BudgetCategoryCardProgressBarStyled = styled.div<IBudgetCategoryCardProgressBarStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  padding-bottom: 0;

  figure {
    cursor: pointer;
  }
`
